import * as React from 'react';
import { NewIndexPage } from 'pages/NewIndexPage';
import { ProjectPage } from 'pages/ProjectPage';
import { Route, Routes } from 'react-router-dom';
import { TutorialProvider } from 'tutorials/tutorial.context';
import { Tutorial } from 'tutorials/Tutorial';
import { TemplateIndexPage } from 'pages/TemplateIndexPage';
import { TemplatePage } from 'pages/TemplatePage';
import { ExampleProjectPage } from 'pages/ExampleProjectPage';
import { IndexProvider } from 'contexts/index.context';

export const ItemAuthNavigator = () => {
  return (
    <TutorialProvider>
      <Tutorial />
      <Routes>
        <Route path="/project_template/:id" element={<TemplatePage />} />
        <Route path="/project_template" element={<TemplateIndexPage />} />
        <Route path="/project/example" element={<ExampleProjectPage />} />
        <Route path="/project/:id" element={<ProjectPage />} />
        <Route
          path="/"
          element={
            <IndexProvider>
              <NewIndexPage />
            </IndexProvider>
          }
        />
      </Routes>
    </TutorialProvider>
  );
};
